import { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Box, Typography } from "@mui/material";

import { useReleaseNotesStore } from "../hooks/useReleaseNotesStore";
import LoadingSpinner from "../components/ui/LoadingSpinner";
import { formatCivilDate } from "../components/helpers/dataHelper";
import MarkdownRenderer from "../components/ui/MarkdownRenderer";

export const ReleaseNotes = observer(() => {
  const { isListLoading, releaseVersions, loadReleaseVersions } =
    useReleaseNotesStore();

  useEffect(() => {
    loadReleaseVersions();
  }, []);

  return (
    <main className="grow flex flex-col bg-hex-gray-100 flex-col h-[calc(100%-6rem)]">
      {isListLoading ? (
        <Box
          sx={{
            flex: 1,
            overflow: "auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <LoadingSpinner text="Loading data..." />
        </Box>
      ) : (
        <Box
          sx={{
            maxWidth: "1000px",
            width: "100%",
            margin: "0 auto",
            padding: 3,
            height: "100%",
          }}
        >
          <Typography variant="h4" sx={{ mb: 3 }}>
            Release notes
          </Typography>

          {releaseVersions.length === 0 ? (
            <Box
              sx={{
                background: "white",
                display: "flex",
                alignItems: "center",
                border: "1px solid",
                borderColor: "divider",
                borderRadius: "10px",
                padding: 4,
              }}
            >
              <Typography variant="body2" color="text.secondary">
                No data to display
              </Typography>
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1.5,
                maxHeight: "80vh",
                overflowY: "auto",
              }}
            >
              {releaseVersions.map((version) => (
                <Box
                  key={version.id}
                  sx={{
                    background: "white",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    gap: 2,
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: "10px",
                    padding: 2,
                  }}
                >
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        color: "custom.brandTeal",
                        width: "fit-content",
                        mb: 4,
                      }}
                    >
                      {version.title}
                    </Typography>

                    {version?.content ? (
                      <MarkdownRenderer content={version.content} />
                    ) : null}
                  </Box>

                  <Typography
                    variant="body2"
                    sx={{
                      color: "text.secondary",
                      fontStyle: "italic",
                      flexShrink: 0,
                    }}
                  >
                    {version.release_date
                      ? formatCivilDate(version.release_date)
                      : "-"}
                  </Typography>
                </Box>
              ))}
            </Box>
          )}
        </Box>
      )}
    </main>
  );
});
